































import BaseComponent from '@/components/base-component.vue';
import InputMoney from '@/components/UI/input-money.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import { toNumber } from '@/helpers/toNumber';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';


@Component({
  components: { InputMoney },
})
export default class UiPrescriptionVolumeTotal extends BaseComponent {
  @Prop({
    default: 0,
  })
  public typedVolume: number;
  @Prop({
    default: 0,
  })
  public wantedVolume: number;
  @Prop({
    default: true,
  })
  public canUseTypedVolume: boolean;
  @Prop({
    default: {},
  })
  public patient: any;
  @Prop({
    default: false,
  })
  public disabled?: boolean;
  @Prop({
    default: false,
  })
  public useCaloricWeight: boolean;

  @Prop({
    default: false,
  })
  public volumeDigitadoPorKg: boolean;

  public rules: any = {
    volume_final: [(v) => !!v || 'Digite um volume final'],
  };

  public volumeTotal: number = 0;
  public volumeTotalByWeight: number = 0;
  public useTypedVolume: boolean = true;
  
  private onChangeVolume() {
    if (this.volumeDigitadoPorKg) {
      this.onChangeVolumeTotalByWeight();
    } else {
      this.onChangeVolumeTotal();
    }
  }

  @Watch('patient.peso')
  public onChangePatientWeight(): void {
    this.onChangeVolume();
  }

  @Watch('patient.pesoCalorico')
  public onChangePatientCaloricWeight(): void {
    this.onChangeVolume();
  }

  @Watch('useCaloricWeight')
  public onChangeUseCaloricWeight(): void {
    this.onChangeVolume();
  }

  @Watch('typedVolume')
  public onChangeTypedVolume(): void {
    if (this.useTypedVolume && this.canUseTypedVolume) {
      this.volumeTotal = this.typedVolume;
      this.onChangeVolumeTotal();
    }
  }

  @Watch('wantedVolume')
  public onChangeWantedVolume(val): void {
    this.volumeTotal = this.wantedVolume;

    if (!this.useTypedVolume) {
      this.manualOrAutomatic(val);
    }

    this.onChangeVolumeTotal();
  }

  public onChangeVolumeTotalByWeight(): void {
    if (!this.patient) {
      return;
    }
    const result =
      toNumber(this.volumeTotalByWeight) * this.getWeightToUse();
    this.volumeTotal = isFinite(result)
      ? toNumber(decimalFormat(result), true)
      : 0;
    this.onChangeVolumeTotalHandler(this.volumeTotal);
    this.$emit('changeVolumeTotalByWeight', this.volumeTotalByWeight);
  }

  public onChangeVolumeTotalHandler(val): void {
    this.manualOrAutomatic(val);

    this.onChangeVolumeTotal();
  }

  public calcQSPWater(desejado, digitado): string {
    return decimalFormat(Math.max(desejado - digitado, 0));
  }

  private onChangeVolumeTotal(): void {
    if (!this.patient || !toNumber(this.patient.peso)) {
      this.volumeTotalByWeight = 0;
      return;
    }
    const result = toNumber(this.volumeTotal) / this.getWeightToUse();
    this.volumeTotalByWeight = isFinite(result)
      ? toNumber(decimalFormat(result), true)
      : 0;

    this.$emit('changeVolumeTotal', this.volumeTotal);
  }

  private manualOrAutomatic(val): void {
    const isEmpty = () => !val || !toNumber(val);
    if (isEmpty()) {
      this.useTypedVolume = true;
      this.volumeTotal = this.typedVolume;
    } else {
      this.useTypedVolume = false;
      this.volumeTotal = toNumber(decimalFormat(val), true);
    }
  }

  public onChangeVolumeTipo(val): void {
    this.$emit('changeVolumeTipo', val);
  }

  private getWeightToUse() {
    return toNumber(this.useCaloricWeight ?
                      this.patient.pesoCalorico : 
                      this.patient.imc && this.patient.imc.pesoIdeal ? 
                      this.patient.imc.pesoIdeal: 
                      this.patient.peso);
  }
}
